module.exports = "<div class=\"change-password-container\">\r\n\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./App/Components/change-password.component.html
// module id = 549
// module chunks = 1